import React, { useState, useEffect } from 'react'
import './Document.css'
import DocumentWindow from '../../component/document/DocumentWindow'
import DocumentForm from '../../component/document/DocumentForm'
import 'react-datepicker/dist/react-datepicker.css'
//Redux
import { useDispatch } from 'react-redux'
import { setTitle } from '../../redux'

function CreateDocumentForm() {
  const [file, setFile] = useState(undefined)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setTitle('Create Document'))
  }, [])
  return (
    <div className='document-container '>
      <div className='form-style'>
        <DocumentForm file={file} setFile={setFile} />
      </div>
      <div className='window-style'>
        <DocumentWindow file={file} />
      </div>
    </div>
  )
}

export default CreateDocumentForm
